// MusicBrainz lookup helpers — all calls are proxied through the backend so
// the correct User-Agent header reaches MusicBrainz (browsers forbid setting it).
import api from './api';

/**
 * Search artists on MusicBrainz by name.
 */
export async function searchArtists(query, limit = 10) {
  if (!query || query.trim().length === 0) return [];

  const response = await api.get('/admin/artists/musicbrainz-search', {
    params: { q: query.trim(), limit: Math.min(limit, 100) },
  });

  return response.data.artists || [];
}

/**
 * Look up MusicBrainz artists by an external URL (Spotify, YouTube, etc.)
 * via the backend proxy, which serialises per-artist fetches for rate limiting.
 */
async function searchArtistsByUrl(externalUrl) {
  if (!externalUrl) return [];

  const response = await api.get('/admin/artists/musicbrainz-lookup-url', {
    params: { resource: externalUrl },
  });

  return response.data.artists || [];
}

/**
 * Look up a MusicBrainz artist by Spotify ID.
 */
export async function searchArtistBySpotifyId(spotifyId) {
  return searchArtistsByUrl(`https://open.spotify.com/artist/${spotifyId}`);
}

/**
 * Look up a MusicBrainz artist by a YouTube channel URL (e.g. links.youtube).
 * Accepts full URLs like https://www.youtube.com/channel/UCxxx or https://www.youtube.com/@handle.
 */
export async function searchArtistByYoutubeUrl(youtubeUrl) {
  return searchArtistsByUrl(youtubeUrl);
}

/**
 * Format an artist hit for display in the picker.
 */
export function formatArtistData(artist) {
  return {
    mbid: artist.id,
    name: artist.name,
    sortName: artist['sort-name'],
    type: artist.type || null,
    country: artist.country || null,
    disambiguation: artist.disambiguation || null,
    score: artist.score || 0,
    lifeSpan: artist['life-span'] || {},
    area: artist.area?.name || null,
    rawData: artist,
  };
}
